import { isValid, parse, sub, isBefore } from 'date-fns';

export const getDates = (startDate, endDate) => {
    const dates = [];

    while (startDate <= endDate) {
        dates.push(new Date(startDate));
        startDate.setDate(startDate.getDate() + 1);
    }
    return dates;
};

export const isWeekend = (weekend) => weekend.getDay() === 0 || weekend.getDay() === 6;

export const validateDateField = (fieldName, date, errors, setErrors) => {
    const validationErrors = { ...errors };
    if (!date) {
        validationErrors[fieldName] = `${formatFieldName(fieldName)} is required`;
    } else if (!isValid(date)) {
        validationErrors[fieldName] = `Invalid ${formatFieldName(fieldName)}`;
    } else {
        delete validationErrors[fieldName];
    }
    setErrors(validationErrors);
};

const formatFieldName = (fieldName) => {
    return fieldName.replace(/([A-Z])/g, ' $1').trim();
};

export const isDateStringOlderThan = (dateString, { years = 0, months = 0 }) => {
    const inputDate = parse(dateString, 'dd.MM.yyyy', new Date());

    if (!isValid(inputDate)) {
        return false;
    }

    const thresholdDate = sub(new Date(), {
        years: years,
        months: months,
    });

    return isBefore(inputDate, thresholdDate);
};
